import {  useParameter } from "../../../shared";

export function useHistoricalFootnote() {
  const [commodity] = useParameter<number>('@commodities');

  switch (commodity) {
    case 201: return "Corn, no. 2, U.S. Gulf, USD/mt";
    case 701: return "Rapeseed, EU CIF, Hamburg, USD/mt";
    case 1001: return "Rice, 100% White B, Bangkok, USD/mt";
    case 1101: return "Soybeans, no. 1, Yellow, U.S. Gulf, USD/mt";
    case 103: return "Wheat, no. 1, HRW, Gulf, FOB, USD/mt";
    default: return "";
  }
}